import { media, pxToRem, Text, Modal } from "@ottatech/design";
import styled from "styled-components";
import { pushAnalyticsEvent } from "@ottatech/analytics";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as queryString from "query-string";

import { NextButtonModalContents } from "./NextButtonModalContents";
import { NextAndApplyButtons } from "./NextAndApplyButtons";

import { PublicJobQuery } from "schema";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${pxToRem(16)};
  ${media({ from: "desktop" })`
    align-items: flex-start;
  `};
  ${media({ to: "desktop" })`
    margin-right: -${pxToRem(18)};
  `};
`;

interface IPublicActionPanelProps {
  job: NonNullable<PublicJobQuery["publicJob"]>;
  utmSource?: string;
}

const NextHeader = <Text bold>Sign up to Otta to see more jobs</Text>;

export function PublicJobActionPanel({
  job,
  utmSource,
}: IPublicActionPanelProps): React.ReactElement {
  const navigate = useNavigate();

  const [showNextModal, setShowNextModal] = useState(false);

  const handleClose = () => {
    setShowNextModal(false);
  };

  const handleApply = useCallback(() => {
    if (job.originalUrl) {
      pushAnalyticsEvent({
        eventName: "Clicked Public Apply Link",
        jobId: job.externalId,
        utmSource,
      });

      window.open(job.originalUrl);
    } else {
      navigate({
        pathname: `/apply/sign-up/${job.externalId}`,
        search: queryString.stringify({
          utm_source: utmSource,
          redirect: `/jobs/${job.externalId}/apply`,
        }),
      });
    }
  }, [job.originalUrl, job.externalId, utmSource, navigate]);

  return (
    <>
      <Container data-testid="public-job-action-panel">
        <NextAndApplyButtons
          canApply={job.live}
          handleApply={handleApply}
          handleNext={() => setShowNextModal(true)}
        />
      </Container>
      {showNextModal && (
        <Modal headerContent={NextHeader} onClose={handleClose}>
          <NextButtonModalContents
            utmSource={utmSource}
            externalId={job.externalId}
          />
        </Modal>
      )}
    </>
  );
}
